import { Injectable } from '@angular/core';
import { AbstractSandbox } from 'app/core/sandboxes/abstract.sandbox';
import { ActiveCustomerService } from 'app/core/services/active-customer.service';
import * as ordersActions from 'app/core/store/orders/orders.actions';
import * as orderDetailActoins from 'app/core/store/order-detail/order-detail.actions';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { Observable } from 'rxjs';
import { FilterValuesService } from '../services/filter-values.service';
import { SessionState } from '../store/session/session.interface';
import { first } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OrdersSandbox extends AbstractSandbox {
  constructor(private filterValuesService: FilterValuesService, private activeCustomerService: ActiveCustomerService) {
    super();
  }

  resetOrdersFilterValues(): void {
    this.store.dispatch(new ordersActions.OrdersFilterValuesResetAction());
  }

  loadOrdersFilterValues(): Observable<void> {
    return this.filterValuesService.loadOrdersFilterValues(this.handleFail.bind(this));
  }

  async setActiveCustomer(customer: Customer): Promise<void> {
    await this.activeCustomerService.setActiveCustomer(customer);
  }

  /**
   * Bugfix for RFC 1375
   * Bug description: copy order, refresh page, fill in the empty order, use recurrence, create order --> FAILS
   * Active customer is not set in state upon refresh
   * Bugfix: add active customer on reload
   */
  setActiveCustomerOnCopyReload() {
    this.store
      .select('session')
      .pipe(first())
      .subscribe((session: SessionState) => {
        const selectedCustomer = session.selectedCustomer.data;
        const isSuperUser = session.userContext.isSuperUser;
        this.store.dispatch(new orderDetailActoins.OrderDetailSetActiveCustomerAction({ selectedCustomer, isSuperUser }));
      });
  }
}
